/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditCategoryInfo } from './AuditCategoryInfo';
import {
    AuditCategoryInfoFromJSON,
    AuditCategoryInfoFromJSONTyped,
    AuditCategoryInfoToJSON,
    AuditCategoryInfoToJSONTyped,
} from './AuditCategoryInfo';
import type { PaginationMetadata } from './PaginationMetadata';
import {
    PaginationMetadataFromJSON,
    PaginationMetadataFromJSONTyped,
    PaginationMetadataToJSON,
    PaginationMetadataToJSONTyped,
} from './PaginationMetadata';
import type { SeverityInfo } from './SeverityInfo';
import {
    SeverityInfoFromJSON,
    SeverityInfoFromJSONTyped,
    SeverityInfoToJSON,
    SeverityInfoToJSONTyped,
} from './SeverityInfo';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Response containing audit metadata for frontend use
 * @export
 * @interface AuditMetadataResponse
 */
export interface AuditMetadataResponse {
    /**
     * Available audit categories with descriptions
     * @type {Array<AuditCategoryInfo>}
     * @memberof AuditMetadataResponse
     */
    categories?: Array<AuditCategoryInfo>;
    /**
     * Available severity levels with descriptions
     * @type {Array<SeverityInfo>}
     * @memberof AuditMetadataResponse
     */
    severities?: Array<SeverityInfo>;
    /**
     * Available resource types
     * @type {Array<string>}
     * @memberof AuditMetadataResponse
     */
    resourceTypes?: Array<string>;
    /**
     * Available actions
     * @type {Array<string>}
     * @memberof AuditMetadataResponse
     */
    actions?: Array<string>;
    /**
     * Pagination metadata for resource types and actions
     * @type {PaginationMetadata}
     * @memberof AuditMetadataResponse
     */
    pagination?: PaginationMetadata;
    /**
     * 
     * @type {string}
     * @memberof AuditMetadataResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof AuditMetadataResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof AuditMetadataResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof AuditMetadataResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the AuditMetadataResponse interface.
 */
export function instanceOfAuditMetadataResponse(value: object): value is AuditMetadataResponse {
    return true;
}

export function AuditMetadataResponseFromJSON(json: any): AuditMetadataResponse {
    return AuditMetadataResponseFromJSONTyped(json, false);
}

export function AuditMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditMetadataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(AuditCategoryInfoFromJSON)),
        'severities': json['severities'] == null ? undefined : ((json['severities'] as Array<any>).map(SeverityInfoFromJSON)),
        'resourceTypes': json['resourceTypes'] == null ? undefined : json['resourceTypes'],
        'actions': json['actions'] == null ? undefined : json['actions'],
        'pagination': json['pagination'] == null ? undefined : PaginationMetadataFromJSON(json['pagination']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function AuditMetadataResponseToJSON(json: any): AuditMetadataResponse {
    return AuditMetadataResponseToJSONTyped(json, false);
}

export function AuditMetadataResponseToJSONTyped(value?: AuditMetadataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(AuditCategoryInfoToJSON)),
        'severities': value['severities'] == null ? undefined : ((value['severities'] as Array<any>).map(SeverityInfoToJSON)),
        'resourceTypes': value['resourceTypes'],
        'actions': value['actions'],
        'pagination': PaginationMetadataToJSON(value['pagination']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

